import {useQuery} from 'react-query'
import api from '../api'
import {params} from '../commonTypes'

export const useGetCapacityRateQuery = ({from, to, sessions}: params.GetReport) => {
  return useQuery(['getCapacityRate', from, to, sessions], () => api.getCapacityRate({from, to, sessions}))
}
